import type { NextPage } from 'next'
import { useRouter } from 'next/router'


const Component: NextPage = () => {
  const Router = useRouter()

  return (
    <div className='w-full text-white cursor-pointer bg-gg-green py-9 px-9' onClick={() => Router.push('/opinion/participation')}>
      <div className='flex flex-col justify-between h-full'>
        <div>
          <h4 className='text-[36px] font-medium leading-[120%]'>주민의견<br />제출하기</h4>
          <p className='text-[16px] pt-4 font-light'>경기도민 여러분의 다양한<br />의견을 제시해주세요</p>
          <div className='flex justify-start pt-4'>
            <svg xmlns="http://www.w3.org/2000/svg" width="59.977" height="22.298" viewBox="0 0 59.977 22.298">
              <g transform="translate(-1271 -1303.881)" opacity="0.502">
                <path d="M1271,1326.18v-2.33h58.33v2.33Z" fill="#fff"/>
                <path d="M1308.705,1305.531l1.65-1.65,20.622,20.622-1.65,1.65Z" fill="#fff"/>
              </g>
            </svg>
          </div>
        </div>

        <div className='flex justify-end'>
          <svg xmlns="http://www.w3.org/2000/svg" width="74.007" height="77.993" viewBox="0 0 74.007 77.993">
            <g transform="translate(-679.565 -364.589)">
              <g>
                <g>
                  <path d="M702.457,383.7,680.877,399.55h21.632V383.7Z" fill="#007130" stroke="#212121" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.623"/>
                  <path d="M730.679,383.7h-28.17V399.55h28.177V383.7Z" fill="#fff" stroke="#212121" strokeLinejoin="round" strokeWidth="2.623"/>
                  <path d="M730.686,383.7V399.55H752.26Z" fill="#007130" stroke="#212121" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.623"/>
                </g>
                <g>
                  <rect width="32.407" height="44.598" transform="translate(700.365 365.901)" fill="#fff" stroke="#212121" strokeWidth="2.623"/>
                  <rect width="36.601" height="50.374" transform="translate(698.268 370.075)" fill="#fff" stroke="#212121" strokeWidth="2.623"/>
                  <path d="M737.492,374.9v57.592H695.644V374.9" fill="#fff" stroke="#212121" strokeWidth="2.623"/>
                  <line x2="29.062" transform="translate(702.037 383.147)" fill="#fff" stroke="#212121" strokeWidth="2.616"/>
                  <line x2="29.062" transform="translate(702.037 388.765)" fill="#fff" stroke="#212121" strokeWidth="2.616"/>
                  <rect width="32.407" height="44.598" transform="translate(700.365 365.901)" fill="#fff" stroke="#212121" strokeWidth="2.623"/>
                  <rect width="36.601" height="50.374" transform="translate(698.268 370.075)" fill="#fff" stroke="#212121" strokeWidth="2.623"/>
                  <path d="M707.1,374.9h30.394v57.592H695.644V374.9h5.231" fill="#fff" stroke="#212121" strokeWidth="2.623"/>
                  <line x2="3.052" transform="translate(702.301 374.896)" fill="#fff" stroke="#212121" strokeWidth="2.616"/>
                  <line x2="29.062" transform="translate(702.037 383.147)" fill="#fff" stroke="#212121" strokeWidth="2.616"/>
                  <line x2="29.062" transform="translate(702.037 388.765)" fill="#fff" stroke="#212121" strokeWidth="2.616"/>
                </g>
                <path d="M752.26,441.271V399.55H680.877v41.721" fill="#007130"/>
                <path d="M.832,0H24.9a.833.833,0,0,1,.833.833v5.01a.833.833,0,0,1-.833.833H.832A.832.832,0,0,1,0,5.844V.832A.832.832,0,0,1,.832,0Z" transform="translate(703.702 410.397)" fill="#fff" stroke="#212121" strokeLinejoin="round" strokeWidth="2.623"/>
                <path d="M697.5,441.271H752.26V399.55H680.877v41.721H689.8" fill="none" stroke="#212121" strokeLinejoin="round" strokeWidth="2.623"/>
                <line x2="3.434" transform="translate(691.891 441.271)" fill="none" stroke="#212121" strokeLinejoin="round" strokeWidth="2.616"/>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  )
}

export default Component
